module.exports = __webpack_public_path__ + "static/media/icon-uncheck.23c6ba1a.svg";